module.exports = __webpack_public_path__ + "static/media/F9.8f7c825c.jpg";